import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { ServerMessageHandler } from '@swf/notification';

import type { DepositResult } from '../../../../../../types/Cashier';
import { DepositStatus } from '../../../../../../types/status';

import {
  TXTCLI_An_email_has_been_sent_to_you__ELL,
  TXTWCL_There_is_currently_a_problem_d_ELL,
  TXTWCL_To_resolve_this_issueX_please__ELL,
  TXTWCL_Your_account_has_been_suspende_ELL
} from './DepositUnavailable.messages.json';
import { wrapper } from './DepositUnavailable.scss';

type Props = DepositResult;

const DepositUnavailable: React.FC<Props> = ({ status, message }) => {
  const messages: Partial<Record<DepositStatus, JSX.Element>> = {
    [DepositStatus.ERRORS]: (
      <>
        <Translation tagName="p" {...TXTWCL_There_is_currently_a_problem_d_ELL} />
        <Translation tagName="p" {...TXTWCL_To_resolve_this_issueX_please__ELL} />
      </>
    ),
    [DepositStatus.REJECTED_CARD_BLOCKED]: message?.defaultMessage ? (
      <p>
        <ServerMessageHandler message={message.defaultMessage} />
      </p>
    ) : (
      <>
        <Translation tagName="p" {...TXTWCL_Your_account_has_been_suspende_ELL} />
        <Translation tagName="p" {...TXTCLI_An_email_has_been_sent_to_you__ELL} />
      </>
    )
  };

  return <div className={wrapper}>{messages[status]}</div>;
};

export default DepositUnavailable;
